"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _intl = require("@kyruus/intl");
var _formsV = _interopRequireWildcard(require("@kyruus/forms-v2"));
var _providerComponents = require("@kyruus/provider-components");
var _formConfig = _interopRequireDefault(require("./formConfig"));
var _CancelationFailedBanner = _interopRequireDefault(require("./CancelationFailedBanner"));
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _Tracking = require("../../lib/constants/Tracking");
var _utils = require("../../lib/utils");
var _xstate2 = require("../../lib/constants/xstate");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CancelPage = _ref => {
  let {
    service,
    track,
    intl
  } = _ref;
  const [state, send] = (0, _react2.useService)(service);
  const handleClick = formData => {
    const {
      email_consent = true,
      notes = ''
    } = formData.apptCancel || {};
    track(_Tracking.userEvents.CLICK_CANCEL_APPT, {
      [_Tracking.reasonGiven]: (0, _trim.default)(notes).call(notes).length > 0
    });
    send({
      type: _xstate2.events.cancel,
      data: {
        cancelEmailConsent: email_consent,
        cancelReasonText: notes
      }
    });
  };
  const {
    appointment,
    locationId,
    locations,
    provider
  } = state.context;

  // Sidebar adapter
  const appointmentQuery = {
    patientRel: appointment.patientRelationship,
    purpose: {
      name: appointment.patientPurpose
    }
  };
  const selectedAppointment = {
    start_datetime: appointment.startDateTime,
    location_id: locationId
  };
  const formFields = (0, _react.useMemo)(() => (0, _formConfig.default)(intl), [intl]);
  const {
    fields,
    addOns
  } = formFields;
  const providerPhone = (0, _utils.hasProvider)(provider) ? (0, _providerComponents.getProviderContactPhone)(provider) : undefined;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "CancelPage"
  }, /*#__PURE__*/_react.default.createElement(_styles.CancelHeading, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.pageHeading)), /*#__PURE__*/_react.default.createElement(_styles.CancelContentContainer, null, /*#__PURE__*/_react.default.createElement(_styles.CancelTextContainer, null, /*#__PURE__*/_react.default.createElement(_styles.CancelFormWrapper, null, /*#__PURE__*/_react.default.createElement(_formsV.default, {
    onSubmit: handleClick,
    fields: fields,
    submitButtonText: /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.cancelApptButton)
  }, (0, _formsV.getAddOns)(addOns)), state.matches(`${_xstate2.states.cancelPage}.${_xstate2.states.cancelError}`) && /*#__PURE__*/_react.default.createElement(_CancelationFailedBanner.default, {
    phone: providerPhone
  }))), (0, _utils.hasProvider)(provider) && /*#__PURE__*/_react.default.createElement(_styles.CancelSideBar, null, /*#__PURE__*/_react.default.createElement(_providerComponents.ProviderSidebar, {
    provider: provider,
    locations: locations,
    appointmentQuery: appointmentQuery,
    selectedAppointment: selectedAppointment,
    track: track
  }))));
};
CancelPage.propTypes = {
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  track: _propTypes.func.isRequired,
  intl: (0, _propTypes.shape)({
    locale: _propTypes.string.isRequired,
    formatMessage: _propTypes.func.isRequired
  }).isRequired
};
CancelPage.defaultProps = {};
var _default = exports.default = (0, _intl.injectIntl)(CancelPage);
CancelPage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CancelPage",
  "props": {
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "locale": {
            "name": "string",
            "required": true
          },
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    }
  }
};